import angular from 'angular';

import component from './featured-events-phone-preview.component';

const FeaturedEventsPhonePreview = angular
    .module('control-room.commons.content.components.featured-events-phone-preview', [])
    .component('crFeaturedEventsPhonePreview', component);

export default FeaturedEventsPhonePreview;
